import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/circleplug-webapp/circleplug-webapp/components/pages/estate/page.jsx");
